<template src="./review-flow-product.html"></template>

<script lang="ts">
import ProductImage from 'objects/product-image/ProductImage.vue'

export default {
  name: 'AddVideo',
  props: {
    catItem: Object,
    forReviewForm: Boolean,
    siblingSiteKey: String
  },
  components: {
    'tt-product-image': ProductImage
  }
}
</script>

<style lang="scss" src="./review-flow-product.scss"></style>
